// Samsung Pay mobile iframe fix
// ─────────────────────────────────────────────────────────────────────────────
// Root cause: Samsung's SDK calls window.open(bridgeUrl) to open the bridge
// page in a new tab. On a standalone full-page checkout this works fine.
// Inside a cross-origin merchant iframe the browser's popup policy blocks it.
//
// Fix: override window.open in our checkout page context. When Samsung tries to
// open the bridge URL (us-online.mpay.samsung.com/gsmpi-web/mobile/bridge?...),
// we intercept it and navigate the TOP window instead via <a target="_top">.
// An anchor with target="_top" is explicitly allowed from cross-origin iframes
// and does not require a user-gesture popup permission.
//
// Merchant pages only need:
//   window.addEventListener('message', e => {
//     if (e.data?.type === 'SAMSUNG_PAY_BRIDGE_URL') window.location.href = e.data.url
//   })
// ─────────────────────────────────────────────────────────────────────────────
;(function interceptSamsungPayWindowOpen() {
  if (typeof window === 'undefined') return
  if (/Windows|Macintosh|Linux/.test(navigator.userAgent)) return

  var origOpen = window.open.bind(window)
  var handled = false

  window.open = function(url, target, features) {
    if (url && typeof url === 'string' && url.includes('mobile/bridge')) {
      if (handled) return null
      handled = true
      setTimeout(function() { handled = false }, 10000)

      console.log('[SamsungPay] bridge URL intercepted:', url)

      // PRIMARY: postMessage to parent page.
      // The parent's listener calls window.open(url, '_blank') from top-level context
      // (not inside a cross-origin iframe), so popup policy allows it.
      // The bridge page then redirects to samsungpay:// → Samsung Wallet opens.
      try { window.parent.postMessage({ type: 'SAMSUNG_PAY_BRIDGE_URL', url: url }, '*') } catch (e) {}

      // FALLBACK 1: Try opening a new tab directly from checkout iframe.
      // Works if user-activation is still live from the "Continue" tap.
      var winBlank = null
      try { winBlank = origOpen(url, '_blank') } catch (e) {}
      if (winBlank) {
        console.log('[SamsungPay] origOpen _blank → ok')
        return null
      }
      console.log('[SamsungPay] origOpen _blank blocked — relying on parent postMessage')

      // FALLBACK 2: Same-origin top navigation (last resort).
      try { window.top.location.href = url } catch (e) {}

      return null
    }
    return origOpen(url, target, features)
  }
}())

const paymentMethods = {
  version: '2',
  serviceId: '87eb096edfd6442eba2613',
  protocol: 'PROTOCOL_3DS',
  allowedBrands: ['visa', 'mastercard'],
}

const samsungPayRequest = {
  isReadyToPay: async function() {
    if (!window.SamsungPay || !window.SamsungPay.PaymentClient) return false
    const samsungPayClient = new window.SamsungPay.PaymentClient({ environment: 'PRODUCTION' })
    try {
      const response = await samsungPayClient.isReadyToPay(paymentMethods)
      return response.result
    } catch (e) {
      console.error('SamsungPay isReadyToPay error:', e)
      return false
    }
  },
  createButton: function({ onClick, buttonStyle = 'white', type = 'buy' }) {
    if (window.SamsungPay && window.SamsungPay.PaymentClient) {
      const samsungPayClient = new window.SamsungPay.PaymentClient({ environment: 'PRODUCTION' })
      return samsungPayClient.createButton({
        onClick,
        buttonStyle,
        type,
      })
    } else {
      console.error('SamsungPay SDK is not loaded.')
      return null
    }
  },
  loadPaymentSheet: function({ orderNumber, total, merchantName, currency, countryCode, onResult }) {
    if (!window.SamsungPay || !window.SamsungPay.PaymentClient) {
      console.error('SamsungPay SDK is not loaded.')
      return
    }
    if (!orderNumber || !total) {
      console.error('orderNumber and total are required for Samsung Pay')
      if (onResult) onResult(null, new Error('orderNumber and total are required'))
      return
    }
    // merchant.url must be bare domain per Samsung's official example
    const merchantDomain = window.location.hostname

    const samsungPayClient = new window.SamsungPay.PaymentClient({ environment: 'PRODUCTION' })
    const transactionDetail = {
      orderNumber,
      merchant: {
        name: merchantName,
        url: merchantDomain,
        countryCode: countryCode,
      },
      amount: {
        option: 'FORMAT_TOTAL_ESTIMATED_AMOUNT',
        currency: currency,
        // Samsung Pay API requires amount.total as a String
        total: parseFloat(total).toFixed(2),
      },
    }
    console.log('paymentMethods:', paymentMethods)
    console.log('transactionDetail:', transactionDetail)
    samsungPayClient
      .loadPaymentSheet(paymentMethods, transactionDetail)
      .then(function(paymentCredential) {
        if (onResult) onResult(paymentCredential)
        console.log('paymentCredential: ', paymentCredential)
        const paymentResult = {
          status: 'CHARGED',
          provider: 'TEST PG'
        }
        samsungPayClient.notify(paymentResult)
      })
      .catch(function(error) {
        console.log('SamsungPay loadPaymentSheet error:', error)
        if (onResult) onResult(null, error)
      })
  },
}

export default samsungPayRequest
